export default __webpack_public_path__ + "static/media/share-icon.300ac666.svg";